import * as React from "react";
import { Modal, Button } from "antd";
import { TTranslate } from "../../../service/locale/TranslationService";
import { IAdditionalCheckDetails } from "../../../model/reporting/AdditionalCheckDetails";

export interface State {}

export interface Props {
  modalVisible: boolean;
  onChange: () => void;
  translate: TTranslate;
  data?: IAdditionalCheckDetails;
  confirm: () => void;
  loading?: boolean;
}

export default class ConfirmRandomSelectionDialog extends React.Component<
  Props,
  State
> {
  render() {
    const {
      modalVisible,
      onChange,
      translate,
      data,
      confirm,
      loading
    } = this.props;
    return (
      <div>
        <Modal
          title={translate("random_selection.dialog.title")}
          visible={modalVisible}
          onCancel={onChange}
          maskClosable={false}
          footer={[
            <Button key="back" onClick={onChange}>
              {translate("modal_functions.assign_modal.cancel")}
            </Button>,
            <Button
              key="submit"
              type="primary"
              loading={loading}
              onClick={confirm}
            >
              {translate("random_selection.confirm.title")}
            </Button>
          ]}
        >
          <span>
            {translate("random_selection.confirm_msg", {
              field: data?.numberOfCandidates.toString()
            })}
          </span>
        </Modal>
      </div>
    );
  }
}
